var React = require('react');

function Square (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"transform":"translate(-157.000000, -991.000000)","fill":"currentColor"},React.createElement("g",{"transform":"translate(144.000000, 908.000000)"},React.createElement("g",{"transform":"translate(0.000000, 82.000000)"},React.createElement("g",{"transform":"translate(17.000000, 5.000000) rotate(-90.000000) translate(-17.000000, -5.000000) translate(12.000000, -12.000000)"},React.createElement("rect",{"x":"-3.26849658e-13","y":"13","width":"8.11940299","height":"8.42105263","rx":"1"})))))));
}

Square.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 9 9","version":"1.1"};

module.exports = Square;

Square.default = Square;
